// Generic Services
import { sendNwReq, sendNwReqWithAuth } from './network'

// Specific services
import getAllMenus from './menu'
import getAllSettings from './settings'
import { getAllNews, getAcfNewsBySlug, getNewsCategories } from './news'
import { getAllProjects, getAcfProjectsBySlug } from './projects'
import { getAllJobs, getDetailData } from './careers'
import { fetchPageData, fetchPageByGql, getAllBuilderPages, getPageBySlug } from './page'
import { fetchMagazineData } from './magazine'

export {
  // Generic Services
  sendNwReq,
  sendNwReqWithAuth,
  // Specific services
  getAllMenus,
  // News
  getAllNews,
  getAcfNewsBySlug,
  getNewsCategories,
  // Global Settings
  getAllSettings,
  // Magazine Page
  fetchMagazineData,
  // Projects
  getAllProjects,
  getAcfProjectsBySlug,
  //Careers
  getAllJobs,
  getDetailData,
  // Page Content Builder
  getAllBuilderPages,
  getPageBySlug,
  // Global
  fetchPageData,
  fetchPageByGql,
}
